import { buildDataBindSyntax } from "../../framework/components/buildDataBindSyntax";
import { ll } from "../../framework/core/ll";
import { isFunction } from "../../framework/core/util";
import { buildODataKendoParams } from "../../framework/data/buildODataKendoParams";
import { dataSource } from "../../framework/data/dataSource";

export function multiSelect(options) {
    options = options || {};

    if (options.zScreen && options.zScreen.id) {
        options.id = options.zScreen.id + "_" + options.id;
    }

    options.autoClose = options.autoClose;
    options.title = options.label;
    options.required = options.required || false;
    options.dataTextField = options.labelField || "CodeNumber";
    options.dataValueField = options.valueField || "Id";
    options.bindValue = options.bindValue == undefined ? null : buildDataBindSyntax(options.bindValue, "input");
    options.url = options.url || null;
    options.filterType = options.filterType || "startswith";
    options.containerClasses = options.containerClasses || "";
    options.containerBind = buildDataBindSyntax(options.containerBind, "container");
    options.bsc = options.bsc || "col-lg-3 col-md-4 col-xs-6";
    options.labelBsc = options.labelBsc || "col-xs-5";
    options.inputBsc = options.inputBsc || "col-xs-7  no-pad";
    options.highlightFirst = options.highlightFirst || false;
    options.observableN2NProperty = options.observableN2NProperty || "";

    options.width = options.width || 500;
    options.filter = options.filter || "startswith";
    options.ignoreCase = options.filter || false;
    options.headerTemplate = options.headerTemplate || '<div class="k-dropdown-header">' +
        '<span class="k-widget k-header code-dropdown">' + (ll((options.columnHeader1 || "Code")) || "Code") + "</span>" +
        '<span class="k-widget k-header code-dropdown">' + (ll((options.columnHeader2 || "Description")) || "Description") + "</span>" +
        "</div>";
    options.itemTemplate = options.itemTemplate || '<span name="#= data.' + (options.columnValue1 || "CodeNumber") + ' #" class="k-state-default k-dropdown-option #: (data.Deleted || data.IsDeleted) ? "deleted" : "" #"><span class="code-dropdown">#: data.' +
        (options.columnValue1 || "CodeNumber") + ' #</span><span class="code-dropdown">#: data.' + (options.columnValue2 || "Value") + " #</span></span>";
    options.tagTemplate = options.tagTemplate || '<span class="multi-select-tag">#:data.CodeNumber#</span>';

    if ($("#" + options.id).data("kendoMultiSelect")) {
        return $("#" + options.id).data("kendoMultiSelect");
    }

    if (!options.dataSource && (options.url || options.entityType)) {
        if (!options.url && options.entityType) {
            options.url = "" + options.entityType;
        } else if (!options.entityType) {
            var lastIndex = options.url.lastIndexOf("/");
            options.entityType = options.url.substring(lastIndex + 1);
        }

        var ds = dataSource({
            transport: {
                read: {
                    url: options.url,
                    contentType: "application/json"
                },
                parameterMap: function (data) {
                    var sort = options.sortExpression;
                    var filter = options.filterExpression;
                    var select = options.selectExpression;
                    var expand = options.expandExpression;
                    var isFn = false;

                    if (isFunction(sort)) {
                        sort = sort();
                    }

                    if (isFunction(filter)) {
                        filter = filter();
                        isFn = true;
                    }

                    if (isFunction(select)) {
                        select = select();
                    }

                    if (isFunction(expand)) {
                        expand = expand();
                    }

                    return buildODataKendoParams({
                        data: data,
                        sortExpression: sort,
                        filterExpression: filter,
                        selectExpression: select,
                        expandExpression: expand,
                        isFunction: isFn
                    });
                }
            }
        });
        options.dataSource = ds;
    }

    if (options.observable) {
        options.change = function (e) {
            var items = this.value(),
                clonedItems = items.slice(0),
                indexToRemove = -1;

            $.each(options.observable[options.observableProperty],
                function (index, row) {
                    if (items.indexOf(row[options.observableN2NProperty + "Id"]) == -1) {
                        // We do have it and it no longer exists in the data so delete it to the observable
                        if (row.Id) {
                            row.set("IsDeleted", "true");
                            row.set("DeletedDateTime", new Date().toISOString());
                        } else {
                            indexToRemove = index as any;
                        }
                    } else {
                        if (clonedItems.length == 1) {
                            clonedItems = [];
                        } else {
                            clonedItems.remove(row[options.observableN2NProperty + "Id"]);
                        }
                    }
                });

            if (indexToRemove > -1) {
                options.observable[options.observableProperty].splice(indexToRemove, 1);
            }

            $.each(clonedItems,
                function (index, newItem) {
                    // We do not have it in the observable so delete it
                    var newObject = {};

                    newObject[options.observableN2NProperty + "Id"] = newItem;
                    newObject[options.parentObservableProperty + "Id"] = options.observable.Id;

                    options.observable[options.observableProperty].push(newObject);
                });

            options.observable.set(options.observableProperty, options.observable[options.observableProperty]);
        };
    }

    options.dataBound = options.dataBound || function (e) {
        var listItems = this.list.find(".k-item");

        listItems.each(function (i) {
            var elem = $(this);
            if (elem.children(".deleted").length != 0) {
                elem.hide();
            }
        });
    };

    delete options.zScreen;

    var kendoMultiSelect = $("#" + options.id).kendoMultiSelect(options).data("kendoMultiSelect");

    (kendoMultiSelect as any).zBindRefresh = function () {
        if (options.observable) {
            var items = [];
            $.each(options.observable[options.observableProperty], function (index, row) {
                if (options.observableN2NProperty) {
                    row = row[options.observableN2NProperty];
                }

                items.push(row[options.dataValueField]);
            });
            kendoMultiSelect.value(items);
            kendoMultiSelect.refresh();
        }
    };

    if (options.width) {
        kendoMultiSelect.list.width(options.width);
    }

    if (options.disabled && kendoMultiSelect) {
        kendoMultiSelect.enable(!options.disabled);
    }

    if (options.readonly && kendoMultiSelect) {
        kendoMultiSelect.readonly(true);
    }

    kendoMultiSelect.bind("open", () => $(":focus").blur());

    return kendoMultiSelect;
}
